module.exports = __webpack_public_path__ + "media/proksee-viewer/images/search-cancel-ba74af2dc47ab2be3bb47062862fca71.png";